import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogRef } from "@angular/material/dialog";

import { TranslatePipe } from "../../../shared/i18n/translate.pipe";
import { ConsentService } from "../../services/consent.service";

@Component({
  selector: "app-consent-popup",
  templateUrl: "./consent-popup.component.html",
  styleUrls: ["./consent-popup.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, TranslatePipe],
})
export class ConsentPopupComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<ConsentPopupComponent>>(MatDialogRef);
  readonly consentService = inject(ConsentService);

  ngOnInit() {}

  onGiveConsent() {
    this.consentService.setState(true);
    this.dialogRef.close();
  }
}
